import React, { RefObject, forwardRef, useContext } from 'react';
import { Box, Flex, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { ReactComponent as DatePickerCalendar } from 'svg/common/date-picker-calendar.svg';
import { formatBrandCalendarDate } from 'ts/common/components/date-picker/brandCalendarDateFormat';
import { DatePickerContext } from './DatePicker';

const DatePickerInput = forwardRef(function DatePickerInput(props, ref) {
    const { isInvalid, open, value, brandLocale, brandTimezone } = useContext(DatePickerContext);

    const {
        onClick,
        onFocus,
        value: propsValue,
        ...restProps
    } = props as {
        onClick?: (event: unknown) => void;
        onFocus?: (event: unknown) => void;
        value?: string;
        [k: string]: unknown;
    };

    const displayValue = value
        ? formatBrandCalendarDate(value, {
              brandLocale,
              fallbackLocale:
                  typeof navigator !== 'undefined' && typeof navigator.language === 'string'
                      ? navigator.language
                      : undefined,
              timeZone: brandTimezone,
              preset: 'numeric'
          })
        : propsValue;

    return (
        <Flex ref={ref as RefObject<HTMLDivElement>} role="group">
            <InputGroup>
                <InputRightElement>
                    <Box onClick={open} cursor="pointer" padding="8px" marginLeft={undefined}>
                        <DatePickerCalendar />
                    </Box>
                </InputRightElement>
                <Input
                    isInvalid={isInvalid}
                    isReadOnly={true}
                    {...restProps}
                    value={displayValue}
                    onClick={(e) => {
                        onClick?.(e);
                        open();
                    }}
                    onFocus={(e) => {
                        onFocus?.(e);
                        open();
                    }}
                />
            </InputGroup>
        </Flex>
    );
});

export default DatePickerInput;
